import * as Yup from 'yup';

export const DeleteSchema = Yup.object().shape({
  deleteInput: Yup.string()
    .required('This field is required')
    .max(6, 'Maximum length is 6 characters')
    .test('is-delete', 'You must type DELETE to confirm', (value) => value === 'DELETE'),
});
